import { BaseEntity } from "../base/base-entity";

const RankList = [1, 2, 3, 4, 5] as const;

export type RankListLiterals = (typeof RankList)[number];

export type CustomerReviewType = {
  id: string;
  applicationId: string;
  procedureId: string;
  procedureName: string;
  answerRank: RankListLiterals;
  comment?: string;
  createdAt: Date;
};

class CustomerReview extends BaseEntity {
  id: string;
  applicationId: string;
  procedureId: string;
  answerRank: RankListLiterals;
  comment: string;
  createdAt: Date;

  constructor(values: CustomerReviewType) {
    super();
    this.id = values.id;
    this.applicationId = values.applicationId;
    this.procedureId = values.procedureId;
    this.answerRank = values.answerRank;
    this.comment = values.comment!;
    this.createdAt = values.createdAt;
  }
}

export class CustomerReviewWithProcName extends CustomerReview {
  procedureName: string;

  constructor(values: CustomerReviewType) {
    super(values);
    this.procedureName = values.procedureName;
  }

  static fromJSON(values: CustomerReviewType) {
    return new CustomerReviewWithProcName(values);
  }

  static fromJSONArray(json?: CustomerReviewType[]) {
    if (!json) {
      return [];
    }
    return json.map(CustomerReviewWithProcName.fromJSON);
  }
}
